import { DonationIntervals, PaymentMethods, ReceiverTypes } from 'api-graphql-types'
import { z } from 'zod'
import { report } from '@/errorReporting'
import {
  htmlColorString,
  htmlColorStringWithoutTransparent,
  numericString,
  receiverTypePathParam,
  slug,
  utmParamSchema,
} from '@/schema'
import { cappedString64, requiredCappedString64 } from '@/schema/sanitizedText'
 

 
export const donationAmountSchema = z.coerce
  .number()
  .transform((val) => val * 100)
  .optional()

const defaultIntervalSchema = z.preprocess(
  (val) => (typeof val === 'string' ? val.toUpperCase() : val),
  z
    .enum([DonationIntervals.Monthly, DonationIntervals.Single, DonationIntervals.Yearly])
    .optional()
    .catch(({ issues }) => {
      report({ issues })
      return DonationIntervals.Single
    })
)

const defaultPaymentMethodSchema = z.preprocess(
  (val) => (typeof val === 'string' ? val.toUpperCase() : val),
  z
    .enum([
      PaymentMethods.DirectDeposit,
      PaymentMethods.Paypal,
      PaymentMethods.StripeSepaDebit,
      PaymentMethods.StripeCc,
      PaymentMethods.DummyPayment,
      PaymentMethods.StripeApplePay,
      PaymentMethods.StripeGooglePay,
    ])
    .optional()
    .catch(({ issues }) => {
      report({ issues })
      return PaymentMethods.Paypal
    })
)

 
export const bottomLogoOptions = z.union([z.literal('white'), z.literal('disabled'), z.coerce.boolean()]).optional()

const getDonationFormConfigSchema = z.object({
  slug,
  receiverType: receiverTypePathParam.transform((val) =>
    val === 'projects' ? ReceiverTypes.Project : ReceiverTypes.FundraisingEvent
  ),
  channel: requiredCappedString64,
  background_color: htmlColorString.optional(),
  bottom_logo: bottomLogoOptions.catch(false),
  color: htmlColorStringWithoutTransparent.optional(),
  codonation_cents: z.coerce.number().int().optional(),
  client_reference: cappedString64,
  default_interval: defaultIntervalSchema.optional(),
  default_payment_method: defaultPaymentMethodSchema.optional(),
  donation_amount: donationAmountSchema,
  need_id: numericString.optional(),
  utm_campaign: utmParamSchema,
  utm_medium: utmParamSchema,
  utm_source: utmParamSchema,
  tracking_via: utmParamSchema,
})
export type GetDonationFormConfigInput = z.input<typeof getDonationFormConfigSchema>

export type DonationFormSearchParams = Omit<
  z.output<typeof getDonationFormConfigSchema>,
  'slug' | 'receiverType' | 'channel'
>
export default getDonationFormConfigSchema
